<template>
  <div id="topbar">
    <div class="sav-container flex flex-space-between">
      <span id="topbar-username">Γεια σου, {{ authorName }}!</span>
      <div class="flex">
          <router-link to="/users" v-if="admin" id="topbar-users">Διαχείριση χρηστών</router-link>
          <router-link to="/profile" id="topbar-password">Προφίλ</router-link>
          <span @click="logout" id="topbar-logout">Αποσύνδεση</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
        name: 'Topbar',
        isLoading: true,
        authorName: JSON.parse(localStorage.getItem('sav-erp-user')).username,
        admin: JSON.parse(localStorage.getItem('sav-erp-user')).admin
      }
  },
  methods: {
    logout: function () {
        localStorage.removeItem('user');    
        this.$cookie.delete('sav-erp-token');
        this.$cookie.delete('sav-erp-refresh-token');
        this.$router.push("/login");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";
#topbar {
    background-color: $blue;
    height: 40px;
    color: white;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

#topbar-username {
    padding-right: 45px;
}

#topbar-users,
#topbar-password {
    padding-right: 45px;
}

#topbar-logout {
    position: relative;
    padding-left: 45px;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        border-left: 1px solid white;
    }
}
</style>
